import React, { useState } from "react";
import styles from "./ActiveBitrixContainer.module.scss";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setUpdateBitrix } from "../../store/slices/integrationSlice";
import { AllInfoContainer } from "./components/AllInfoContainer/AllInfoContainer";
import { TrashIcon } from "../../assets/icons/TrashIcon";
import { useNavigate } from "react-router-dom";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";
import { CategoryContainer } from "./components/CategoryContainer/CategoryContainer";
import {
  deleteIntegrationBitrix,
  getIntegrationBitrix,
} from "../../utils/api/actions/integrations/bitrix";
import { getTelegramIntegrations } from "../../utils/api/actions/integrations/telegram";
import { getWhatsappIntegrations } from "../../utils/api/actions/integrations/whatsapp";

export const ActiveBitrixContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeBitrix, updateBitrix, updateDataBitrix, errorBitrix } =
    useSelector((state) => state?.integration);
  const { dataTg, dataWa } = useSelector((state) => state.integration);

  // интеграции тг ва
  const combinedDataMessengers = React.useMemo(() => {
    return [
      ...(dataTg || []).map((tg) => ({ ...tg })),
      ...(dataWa || []).map((wa) => ({ ...wa })),
    ];
  }, [dataTg, dataWa]);

  const [activeNav, setActiveNav] = useState("all info");
  const [isLoading, setIsLoading] = useState(false);

  const navItems = [
    {
      name: "Общая информация",
      value: "all info",
      component: (
        <AllInfoContainer
          activeBitrix={activeBitrix}
          errorBitrix={errorBitrix}
        />
      ),
    },
    {
      name: "Воронки",
      value: "categories",
      component: (
        <CategoryContainer
          combinedDataMessengers={combinedDataMessengers}
          categories={activeBitrix?.dataCategories}
        />
      ),
    },
  ];

  const valueObserver = (e) => {
    e.stopPropagation();
    setActiveNav(e.target.id);

    dispatch(
      getIntegrationBitrix(
        activeBitrix?.dataUser.userId,
        activeBitrix?.dataUser.clientId,
        setIsLoading
      )
    );
    dispatch(getTelegramIntegrations(activeBitrix?.dataUser.userId));
    dispatch(getWhatsappIntegrations(activeBitrix?.dataUser.userId));
  };

  const handleDelete = () => {
    let data = {
      userId: activeBitrix?.dataUser.userId,
      clientId: activeBitrix?.dataUser.clientId,
    };
    dispatch(deleteIntegrationBitrix(data, setIsLoading, navigate));
  };

  const renderNavItems = (arr) => {
    return arr.map((el, index) => {
      return (
        <div
          key={`vk-${index}`}
          className={
            el.value === activeNav ? styles.activeNavItem : styles.navItem
          }
          id={el.value}
          onClick={valueObserver}
        >
          {el.name}
        </div>
      );
    });
  };

  const renderBodyItems = (arr) => {
    return arr
      .map((item) => {
        if (item.value === activeNav) {
          return <div key={item.value}>{item.component}</div>;
        }
        return null;
      })
      .filter(Boolean);
  };

  const errorEmptyAssistantId = () =>
    toast.error("Выберите ассистента!", {
      toastId: "customId",
    });

  const onCancelEdit = () => {
    dispatch(setUpdateBitrix(false));
  };

  const onSaveUpdatedData = () => {
    if (
      updateDataBitrix.assistantId &&
      updateDataBitrix.assistantId !== "00000000-0000-0000-0000-000000000000"
    ) {
      console.log("onSaveUpdatedData");
    } else {
      errorEmptyAssistantId();
    }
  };

  const actions = [
    {
      className: styles.deleteButton,
      titleClassName: styles.titleDeleteButton,
      title: "Удалить",
      icon: <TrashIcon width={16} height={18} fill={"#cb3e3e"} />,
      onClick: handleDelete,
    },
  ];

  return (
    <div className={styles.container}>
      <ScreenHeader
        onCancelEdit={onCancelEdit}
        onSaveUpdatedData={onSaveUpdatedData}
        isEditing={updateBitrix}
        title={"Интеграции"}
        path={"/integration"}
        actions={actions}
      />
      <div className={styles.navContainer}>{renderNavItems(navItems)}</div>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <div
            className={styles.body}
            style={{
              height: errorBitrix && "calc(80% - 40px)",
              justifyContent: errorBitrix && "center",
            }}
          >
            {renderBodyItems(navItems)}
          </div>
        </>
      )}
    </div>
  );
};
